import React, { useEffect, useState } from "react";
import moment from "moment";
import Ledger from "../../../Components/ReportTables/Ledger";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
} from "../../../CommonMethhods/CommonMethods";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import FromdateComponent from "../../Reports/FromdateComponent";
import TodateComponent from "../../Reports/TodateComponent";
import { toast } from "react-toastify";
import DurationChangeComponent from "../../Reports/DurationChangeComponent";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function LedgerNew(props) {
  let clientCode = "";
  const seg = props.seg;
  const storeToken = localStorage.getItem("ssoToken");
  const [fileType, setFileType] = useState("grid");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [gridVal, setGridVal] = useState("");
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [checkDate, setCheckDate] = useState(false);
  const [serverError, setServerError] = useState("");
  const [customShow, setCustomShow] = useState(false)
  const ClientId2 = localStorage.getItem("ClientId2");

  if (fromDate == "" || toDate == "") {
    // const current = new Date();
    // const CurrentYear = current.getFullYear();
    // const CurrentMonth = current.getMonth();
    // if (CurrentMonth < 4) {
    //   const newYear = `04-01-${CurrentYear - 1}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // } else {
    //   const newYear = `04-01-${CurrentYear}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // }
    let date = new Date();
        let firstDay = "";
        let lastDay = "";
        let firstVal = new Date(date.getFullYear(), date.getMonth(), 1);
        firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
        let lastVal = new Date();
        lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
        setFromDate(firstDay)
        setToDate(lastDay)
  }


  const getLedgerReport = async (clientCode) => {
    setLoader(true);
    if (fileType == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
      setLoader(false);
    } else if (fileType == "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderMail(false);
      setSmallLoaderPdf(true);
      setLoader(false);
    } else if (fileType == "mail") {
      setSmallLoaderExcel(false);
      setSmallLoaderMail(true);
      setSmallLoaderPdf(false);
      setLoader(false);
    } else {
      setSmallLoaderExcel(false);
      setSmallLoaderMail(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      clientCode: clientCode || ClientId2,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileType,
      seg: "stocks",
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.LedgerReport_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.data) {
        if (fileType == "grid") {
          setGridVal(res?.data.ledger);
        } else if (fileType == "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType == "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        setGridVal([]);
        if (fileType == "excel") {
          toast.error("Ledger Report does not exist");
        } else if (fileType == "pdf") {
          toast.error("Ledger Report does not exist");
        } else if (fileType == "mail") {
          toast.error("Ledger Report does not exist");
        }
      }
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderMail(false);
      setSmallLoaderPdf(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderMail(false);
      setSmallLoaderPdf(false);
      setServerError("Something went wrong, Please try again later.");
      if (fileType == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "mail") {
        toast.error("Something went wrong, Please try again later.");
      }
    }
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleFromDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setError("");
    setGridVal("");
    setFileType("");
    setServerError("");
  };
  const handleToDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setError("");
    setGridVal("");
    setFileType("");
    setServerError("");
  };
  useEffect(() => {
    if (fileType != "") {
      if (localStorage.getItem("clientCode") || ClientId2) {
        clientCode = localStorage.getItem("clientCode");
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          setCheckDate(false);
          getLedgerReport(clientCode);
          setError("");
        } else {
          setCheckDate(true);
          setGridVal("");
          setError("Please Select Correct Date.");
        }
      }
    }
    // setFileType("");
  }, [fileType]);
  const handleOnClick = (e) => {
    if (fromDate.length > 0 && toDate.length > 0) {
      if (e.target.value) {
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          setFileType(e.target.value);
          setError("");
        } else {
          setCheckDate(true);
          setError("Please Select Correct Date.");
        }
      }
    }
  };
  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const onChangeDuration=()=>{
    setError("");
    setGridVal([]);
    setFileType("");
    setServerError("");
  }
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="ledger-report"
        role="tabpanel"
        aria-labelledby="ledger-report"
      >
        <div className="reports-date-filter">
          <div className="reports-left-form">
            <form>
              <div className="report-form-wrapper">
                <div className="form-group">
                  <DurationChangeComponent
                    setCustomShow={setCustomShow}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    onChangeDuration={onChangeDuration}
                    className="report-custom-select"
                     screen="Client Dashboard"
                    showOptionCustom={false}
                    showOnlyFY={false}

                  />
                </div>
                {customShow && <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                />}

                {customShow && <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={error}
                />}
              </div>
            </form>
            <button
              className="generate-button get-data"
              value="grid"
              onClick={handleOnClick}
            >
              {/* <span class="icon-pdfsvg"></span> */}

              {Constants.Submit}
            </button>
          </div>
          <div className="report-btn-wrapper">
            <button
              className="generate-button mail-btn"
              value="mail"
              onClick={handleOnClick}
            >
              {smallLoaderMail ? (
                // <div>
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-email"></span>
                  E-Mail
                </>
              )}
            </button>

            <button
              className="generate-button excel-btn"
              value="excel"
              onClick={handleOnClick}
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {Constants.Excel}
                </>
              )}
            </button>
            <button
              className="generate-button pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  {Constants.PDF}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : gridVal ? (
        <div>
          <Ledger gridVal={gridVal} seg={"stocks"} />
        </div>
      ) : serverError === "Something went wrong, Please try again later." ? (
        <h4 className="report-table-wrapper">{serverError}</h4>
      ) : (
        ""
      )}
    </>
  );
}
export default LedgerNew;
